export const Footer = ({ c }) => {
  const p = c?.profile || {};
  const year = new Date().getFullYear();
  return (
    <footer className="bg-blue-900 py-10 text-center" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-4">
        <p className="font-display text-xl font-medium text-white">{p.clinic_name}</p>
        <p className="mt-2 text-sm text-blue-100">{[p.name, p.designation].filter(Boolean).join(" · ")}</p>
        {c?.settings?.footer_text && <p className="mt-2 whitespace-pre-line text-sm text-blue-100">{c.settings.footer_text}</p>}
        <p className="mt-3 text-xs text-sky-300">© {year} {p.clinic_name}</p>
      </div>
    </footer>
  );
};
